import { Box, Group, TextInput } from "@mantine/core";
import { AddressInformationProps } from "../../../../types/types";
import { Heading } from "../../heading/heading";


export function AddressInformation(props:AddressInformationProps){
    return (
        <Box
          sx={(theme) => ({
            backgroundColor: theme.colors.gray[0],
            display: "flex",
            justifyContent: "center",
            padding: "16px 0",
            marginTop: "10px",
          })}
        >
          <Box
            sx={(theme) => ({
              width: "65%",
            })}
          >
            <Heading mainHeading="Address Information" subHeading="Please fill your address information" />
            <Box
              sx={() => ({
                marginTop: "16px",
              })}
            >
              <TextInput
                placeholder="House No, Building Name"
                label="Address"
                name="addressLine1"
                value={props.inputs.addressLine1}
                onChange={props.handleChange}
                required
                error={props.formValidation.addressLine1.message}
                onKeyDown={() =>
                  props.setFormValidation({
                    ...props.formValidation,
                    addressLine1: { message: "", isValidated: true },
                  })
                }
              />
              <TextInput
                sx={() => ({
                  marginTop: "12px",
                })}
                placeholder="Road Name, Area, Colony"
                label="Address Line 2"
                name="addressLine2"
                value={props.inputs.addressLine2}
                onChange={props.handleChange}
                required
                error={props.formValidation.addressLine2.message}
                onKeyDown={() =>
                    props.setFormValidation({
                    ...props.formValidation,
                    addressLine2: { message: "", isValidated: true },
                  })
                }
              />
              <Group
                grow
                sx={() => ({
                  width: "100%",
                  marginTop: "12px",
                  alignItems: "flex-start"
                })}
              >
              <TextInput
                placeholder="Enter your email ID"
                label="Email ID"
                name="email"
                value={props.inputs.email}
                onChange={props.handleChange}
                required
                error={props.formValidation.email.message}
                onKeyDown={() =>
                    props.setFormValidation({
                    ...props.formValidation,
                    email: { message: "", isValidated: true },
                  })
                }
              />
              <TextInput
                placeholder="Enter your mobile number"
                label="Mobile Number"
                name="mobile"
                value={props.inputs.mobile}
                onChange={props.handleChange}
                required
                error={props.formValidation.mobile.message}
                onKeyDown={() =>
                    props.setFormValidation({
                    ...props.formValidation,
                    mobile: { message: "", isValidated: true },
                  })
                }
              />
              </Group>
            </Box>
          </Box>
        </Box>
    )
}